export const BASE_PROMPTS: string[] = [
    'Кот, который работает в офисе',
    'Худший день Деда Мороза',
    'Единорог сдаёт экзамен',
    'Пицца, которая боится духовки',
    'Робот выгуливает хозяина',
    'Русалка застряла в пробке',
    'Дракон, который боится огня',
    'Осьминог играет на восьми гитарах одновременно',
    'Снеговик отдыхает на пляже',
    'Зомби на собеседовании',
    'Пингвин мечтает о пустыне',
    'Вампир заказывает доставку крови',
    'Черепаха участвует в гонке Формулы-1',
    'Инопланетянин учится пользоваться вилкой',
    'Кактус пытается обняться',
    'Жираф застрял в лифте',
    'Медведь работает барбером',
    'Слон пытается станцевать балет',
    'Призрак боится темноты',
    'Курица мечтает полететь в космос',
    'Кит учится кататься на скейте',
    'Крот открывает окно с видом на звёзды',
    'Йети приехал на юг погреться',
    'Улитка опаздывает на важную встречу',
    'Сова работает ночным диджеем',
    'Лев боится мышку из соседней квартиры',
    'Паук вяжет себе свитер',
    'Пчела открывает кофейню',
    'Динозавр учится пользоваться смартфоном',
    'Снежный барс загорает в отпуске',
];
